<template>
  <GenericReadonlyComponent
    v-if="computedReadOnly"
    :label="label"
    :labelCols="labelCols"
    :quickEdit="quickEdit"
    @edit="$emit('edit')"
    :value="isoSqlDateToFrenchDate(value)"
  >
    <slot></slot>
  </GenericReadonlyComponent>
  <UnvalidatedInputComponent
    v-else-if="rules == null"
    :label="label"
    :labelCols="labelCols"
    :description="description"
    :prepend="prepend"
    :append="append"
    :disabled="disabled"
    type="date"
    :value="value"
    @input="(value) => $emit('input', value)"
    @change="(value) => $emit('change', value)"
  >
    <template #prepend>
      <slot name="prepend"></slot>
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
  </UnvalidatedInputComponent>
  <ValidatedInputComponent
    v-else
    ref="validatedInput"
    :label="label"
    :labelCols="labelCols"
    :description="description"
    :prepend="prepend"
    :append="append"
    :disabled="disabled"
    :rules="rules"
    type="date"
    :value="value"
    @input="(value) => $emit('input', value)"
    @change="(value) => $emit('change', value)"
  >
    <template #prepend>
      <slot name="prepend"></slot>
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
  </ValidatedInputComponent>
</template>

<script>
import GenericReadonlyComponent from "./GenericReadonlyComponent.vue";
import UnvalidatedInputComponent from "./UnvalidatedInputComponent.vue";
import ValidatedInputComponent from "./ValidatedInputComponent.vue";
import UtilsService from "../../services/utils.service";
export default {
  name: "CustomInputDateComponent",
  components: {
    GenericReadonlyComponent,
    UnvalidatedInputComponent,
    ValidatedInputComponent,
  },
  props: {
    // valeur de l'input
    value: undefined,
    // prepend de l'input group
    prepend: String,
    // append de l'input group
    append: String,
    // propriété label du form-group
    label: {
      type: String,
      required: true,
    },
    // propriété label-cols du form group
    labelCols: [String, Number, Object],
    // propriété label-cols du form group
    description: String,
    // true pour affichage lecture seule (false par défaut)
    readOnly: [Boolean, String],
    // true pour autoriser l'édition rapide (false par défaut)
    quickEdit: [Boolean, String],
    // true pour griser le controle (false par défaut)
    disabled: [Boolean, String],
    // règles de validation à appliquer (aucune par défaut)
    rules: [String, Object],
  },
  computed: {
    computedReadOnly() {
      return this.readOnly === true || this.readOnly === "true";
    },
  },
  methods: {
    isoSqlDateToFrenchDate: UtilsService.isoSqlDateToFrenchDate,
    async validate() {
      await this.$refs.validatedInput?.validate();
    },
  },
};
</script>
